// Hub88 reports balances in the wallet's display unit (BTC wallets are shown in
// mBTC or µBTC), while the header formats from the base currency amount.
const UNIT_DIVISORS: Record<string, number> = {
  mBTC: 1_000,
  uBTC: 1_000_000,
};

const toBaseCurrencyAmount = (
  amount: number | undefined,
  walletCurrency?: string,
): number | undefined => {
  if (amount === undefined) {
    return undefined;
  }
  return amount / (UNIT_DIVISORS[walletCurrency ?? ""] ?? 1);
};

export default toBaseCurrencyAmount;
